import { DataGridWithCheckbox, type DataGridWithCheckboxProps } from '@shared/components';

import { columns } from './columns';

export type ExamCenterCourseAssignmentDataGridProps = Omit<
  DataGridWithCheckboxProps,
  'sx' | 'columns' | 'disableColumnMenu'
>;

export default function ExamCenterCourseAssignmentDataGrid(
  props: Readonly<ExamCenterCourseAssignmentDataGridProps>,
) {
  return (
    <DataGridWithCheckbox
      {...props}
      columns={columns}
      disableColumnMenu
      getRowHeight={() => 48}
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        bgcolor: theme.palette.background.paper,
        '.MuiDataGrid-cell': {
          p: theme.spacing(3),
          alignItems: 'flex-start',
        },
        '.MuiDataGrid-cell.MuiDataGrid-cellCheckbox, .MuiDataGrid-columnHeader.MuiDataGrid-columnHeaderCheckbox':
          {
            p: theme.spacing(0),
          },
        '.MuiDataGrid-columnHeader': {
          p: theme.spacing(3),
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '--DataGrid-overlayHeight': '404px',
      })}
    />
  );
}
